import Vue from 'vue';

export default {
    getCustomForm(context, { formSlug, params }) {
        const url = `v1/site/custom-form/${formSlug}`;
        return Vue.$axios.$get(url, { params });
    },

    getSeekerFields(context, params) {
        const url = 'v1/site/seeker-fields';
        return Vue.$axios.$get(url, { params }).then((response) => {
            context.commit('STORE_SEEKER_FIELDS', response.data);
            return response;
        });
    },
};